import React, { memo, SVGProps } from 'react'

export const Folder = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M18.287 7.27583H13.8106L12.9091 4.92863C12.8026 4.65023 12.5347 4.46687 12.2371 4.46687H5.71391C4.25759 4.46687 3.07391 5.65055 3.07391 7.10687V16.8941C3.07391 18.3504 4.25759 19.5341 5.71391 19.5341H18.288C19.7443 19.5341 20.928 18.3504 20.928 16.8941V9.91583C20.928 8.45951 19.7434 7.27583 18.287 7.27583ZM19.487 16.8941C19.487 17.5555 18.9485 18.0941 18.287 18.0941H5.71295C5.05151 18.0941 4.51295 17.5555 4.51295 16.8941V7.10591C4.51295 6.44447 5.05151 5.90591 5.71295 5.90591H11.7408L12.2669 7.27583H6.64799C6.25055 7.27583 5.92799 7.59839 5.92799 7.99583C5.92799 8.39327 6.25055 8.71583 6.64799 8.71583H18.2861C18.9475 8.71583 19.4861 9.25439 19.4861 9.91583L19.487 16.8941Z"
      fill="currentColor"
    />
  </svg>
))
